import React, { useRef, useState } from 'react';
import { Button, Icon, Input, message, Row, Typography, Dropdown, Menu, Space, Select, Tooltip, Popover } from "antd";
import LanguagePageModals from './LanguagePageModals';
import { AppstoreOutlined, DownloadOutlined, ExportOutlined, FileExcelOutlined, SettingOutlined, SmileOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router';
const { Text } = Typography;
const { Option } = Select;

export default function LanguagePageHeader(props) {
    const { FilterOnSearch } = props;
    // const history = useHistory();
    // const [page, setPage] = useState(history.location.pathname.split("/")[1] === "" ? "whats-new-app" : history.location.pathname.split("/")[1]);

    const childRef = useRef();
    const content = (
        <div>
            {/* <Button
                onClick={(e) => {
                    childRef.current.toggleDeleteModal("Import file")
                }}>
                <ExportOutlined
                    style={{
                        height: "36px",
                        marginRight: "10px",
                    }} />
                <span>Import from XLSX, CSV</span>
            </Button> */}

            <div>
                <Button
                    onClick={(e) => {
                        // childRef.current.toggleDeleteModal("Add Language")
                    }}>
                    <FileExcelOutlined
                        style={{
                            height: "36px",
                            marginRight: "10px",
                        }} />
                    <span>Export Current Table</span>
                </Button>
            </div>
            <div>
                <Button
                    onClick={(e) => {
                        // childRef.current.toggleDeleteModal("Add Language")
                    }}>
                    <a
                        href="http://s3-eu-central-1.amazonaws.com/inaam-app/sample_files/Cohort_Sample_File.xlsx"
                        download
                    >
                        <DownloadOutlined
                            style={{
                                height: "36px",
                                marginRight: "18px",
                            }} />
                        <span>Download Sample File</span>
                    </a>
                </Button>
            </div>
        </div>
    );

    return (
        <div>
            <LanguagePageModals ref={childRef} />
            <Row
                type='flex'
                align='middle'
                justify='space-between'
                style={{
                    marginBottom: "24px",
                }}>
                <Text
                    style={{
                        color: "#181818",
                        /*fontFamily: "Gotham",*/ fontStyle: "normal",
                        fontWeight: "bold",
                        fontSize: "24px",
                        lineHeight: "39px",
                    }}>
                    Languages
                </Text>
                <div style={{ display: "flex" }}>
                    <Input
                        style={{
                            width: "275px",
                            border: "1px solid rgb(0, 0, 0, 0.25)",
                            borderRadius: "5px",
                            alignItems: "left",
                            marginRight: "14px",
                        }}
                        // value={props.searchKey}
                        placeholder={`Search`}
                        onChange={(e) => {
                            // props.setSearchKey(e.target.value);
                            FilterOnSearch(e.target.value)
                        }}
                        prefix={<Icon type='search' />}
                    />
                    {/* <Button
                        onClick={(e) => {
                            childRef.current.toggleDeleteModal("Add Language")
                            // resetErrorLog({
                            //     requestData: {
                            //         error_logs: errorList.map((item) => item.uuid),
                            //     },
                            //     resCallback: () => { },
                            //     res200Callback: (res) => {
                            //         message.success("All Error logs is Successfully Reseted");
                            //         FetchErrorLogAPI();
                            //     },
                            // });
                        }}
                        style={{
                            alignItems: "center",
                            padding: "8px 16px",
                            color: "#000",
                            fontSize: "16px",
                            lineHeight: "24px",
                            background: "#FFFFFF",
                            borderRadius: "5px",
                            height: "100%",
                            marginRight: "14px",
                        }}>
                        <Icon
                            type='plus'
                            style={{
                                height: "16px",
                            }}
                        />
                        Add Language
                    </Button> */}
                    <Button
                        onClick={() => {
                            childRef.current.toggleDeleteModal("Add Label")
                        }}
                        style={{
                            alignItems: "center",
                            padding: "8px 16px",
                            color: "#FFFFFF",
                            fontSize: "16px",
                            lineHeight: "24px",
                            background: "#fec708",
                            borderRadius: "5px",
                            height: "100%",
                            marginRight: "14px",
                        }}>
                        <Icon
                            type='plus'
                            style={{
                                height: "16px",
                            }}
                        />
                        Add Label
                    </Button>
                    <Button
                        onClick={() => {
                            childRef.current.toggleDeleteModal("add_translation")
                        }}
                        style={{
                            alignItems: "center",
                            padding: "8px 16px",
                            color: "#FFFFFF",
                            fontSize: "16px",
                            lineHeight: "24px",
                            background: "#fec708",
                            borderRadius: "5px",
                            height: "100%",
                            marginRight: "14px",
                        }}>
                        <Icon
                            type='plus'
                            style={{
                                height: "16px",
                            }}
                        />
                        Add Translation
                    </Button>
                    {/* <Popover placement="bottomRight" content={content} trigger="click">
                        <Button
                            onClick={(e) => {
                                // resetErrorLog({
                                //     requestData: {
                                //         error_logs: errorList.map((item) => item.uuid),
                                //     },
                                //     resCallback: () => { },
                                //     res200Callback: (res) => {
                                //         message.success("All Error logs is Successfully Reseted");
                                //         FetchErrorLogAPI();
                                //     },
                                // });
                            }}
                            style={{
                                alignItems: "center",
                                padding: "8px 16px",
                                color: "#000",
                                fontSize: "16px",
                                lineHeight: "24px",
                                background: "#FFFFFF",
                                borderRadius: "5px",
                                height: "70%",
                                marginRight: "14px",
                            }}>

                            <Icon
                                type='more'
                                style={{
                                    height: "16px",
                                }}
                            />
                        </Button>
                    </Popover> */}
                </div>
            </Row>
        </div>
    )
}
